import {createRoutingAppLogger} from '@energysavvy/xp-js-logger';

const logger = createRoutingAppLogger('experiences', 'residential-intro-ui');
export default logger;
